"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentFeed_1 = require("../content/ContentFeed");
const EmailCampaign_1 = require("./EmailCampaign");
const EmailTemplate_1 = require("./EmailTemplate");
const EmailTemplateBlock_1 = require("./EmailTemplateBlock");
const EmailTemplateVersion_1 = require("./EmailTemplateVersion");
const Integration_1 = require("../integrations/Integration");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
let Email = 
// TODO: Get the DB to a point where we can form this unique constraint:
// @Unique(['emailNumber', 'workspace'])
class Email extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor() {
        super(...arguments);
        this.relations = {
            all: ['creatingUser'],
            detail: [],
            list: [],
        };
        // @Field(returns => String, { nullable: true })
        // @Column({ type: 'character varying', default: '' })
        // public campaignFromName: string | null;
        // @Field(returns => String)
        // @Column({ default: '' })
        // public campaignFromEmailAddress: string;
        // @Field(returns => String, { nullable: true })
        // @Column({ type: 'character varying', default: '' })
        // public campaignReplyToEmailAddress: string | null;
        // @Field(returns => String, { nullable: true })
        // @Column({ type: 'timestamp', nullable: true })
        // public campaignScheduledDateTime: Date | null;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, { nullable: true }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [auth_1.User]),
    typeorm_1.ManyToMany(() => auth_1.User, user => user.emailsAssigned),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "assignedUsers", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Email.prototype, "renderedHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Email.prototype, "originalHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Email.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Email.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number),
    typeorm_1.Column({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Email.prototype, "emailNumber", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlock_1.EmailTemplateBlock]),
    typeorm_1.OneToMany(() => EmailTemplateBlock_1.EmailTemplateBlock, block => block.email),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "blocks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "workspace", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((email) => email.workspace),
    tslib_1.__metadata("design:type", Number)
], Email.prototype, "workspaceId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Integration_1.Integration, { nullable: true }),
    typeorm_1.ManyToOne(() => Integration_1.Integration, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "emailServiceProvider", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplate_1.EmailTemplate, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailTemplate_1.EmailTemplate, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "emailTemplate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplateVersion_1.EmailTemplateVersion, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailTemplateVersion_1.EmailTemplateVersion, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "emailTemplateVersion", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentFeed_1.ContentFeed, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentFeed_1.ContentFeed, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "defaultContentFeed", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentFeed_1.ContentFeed, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentFeed_1.ContentFeed, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "defaultContentFeedSecond", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailCampaign_1.EmailCampaign, { nullable: true }),
    typeorm_1.OneToOne(() => EmailCampaign_1.EmailCampaign),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "metaCampaign", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailCampaign_1.EmailCampaign], { nullable: true }),
    typeorm_1.OneToMany(() => EmailCampaign_1.EmailCampaign, ec => ec.email),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "campaigns", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "campaignListID", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    typeorm_1.Column({
        array: true,
        nullable: true,
        type: 'character varying',
    })
    // @Column({ type: 'simple-array', nullable: true })
    ,
    class_validator_1.IsArray(),
    tslib_1.__metadata("design:type", Array)
], Email.prototype, "latestSubjectLines", void 0);
tslib_1.__decorate([
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], Email.prototype, "latestSubjectLine", void 0);
Email = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
    // TODO: Get the DB to a point where we can form this unique constraint:
    // @Unique(['emailNumber', 'workspace'])
], Email);
exports.Email = Email;
// export class EmailEntity extends Email {
//   public toString() {
//     return `Email #${this.emailNumber}`;
//   }
//   public async toEndpoint() {
//     return `/emails/${this.emailNumber}`;
//   }
// }
//# sourceMappingURL=Email.js.map